import { FormlyFieldConfig } from '@ngx-formly/core';
import {
    ZopAutoCompleteComponent,
    LabelComponent,
    FormlyFieldStepper,
    ZopFileUploadComponent,
    ZopButtonField,
    AutocompleteTreeTypeComponent,
    TimepickerComponent,
    SelectTagsComponent,
    ZopColorPicker,
    ZopIconPicker,
} from '@zopup/zop-shared';
import { TestAddressComponent } from '@zopup/zop-ux-common';
import { RepeatComponent } from '@zopup/zop-ux-common';

export const types: any[] = [
    { name: 'autocomplete', component: ZopAutoCompleteComponent, wrappers: [] },
    { name: 'label', component: LabelComponent, wrappers: [] },
    { name: 'stepper', component: FormlyFieldStepper, wrappers: [] },
    { name: 'file', component: ZopFileUploadComponent, wrappers: [] },
    {
        name: 'button',
        component: ZopButtonField,
        defaultOptions: {
            props: {
                btnType: 'default',
                type: 'button',
            },
        },
    },
    { name: 'test-address', component: TestAddressComponent, wrappers: [] },
    { name: 'autocomplete-tree', component: AutocompleteTreeTypeComponent },
    { name: 'timepicker', component: TimepickerComponent },
    { name: 'select-tags', component: SelectTagsComponent },
    { name: 'colorpicker', component: ZopColorPicker },
    { name: 'iconpicker', component: ZopIconPicker },
    { name: 'repeat', component: RepeatComponent },
    
];

// Validation messages

export function minLengthValidationMessage(
    error: unknown,
    field: FormlyFieldConfig
) {
    return `Should have atleast ${field.props.minLength} characters`;
}

export function maxLengthValidationMessage(
    error: unknown,
    field: FormlyFieldConfig
) {
    return `This value should be less than ${field.props.maxLength} characters`;
}

export function minValidationMessage(error: unknown, field: FormlyFieldConfig) {
    return `This value should be more than ${field.props.min}`;
}

export function maxValidationMessage(error: unknown, field: FormlyFieldConfig) {
    return `This value should be less than ${field.props.max}`;
}
